import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import talk1 from "../../../Images/talk-1.png";
import talk2 from "../../../Images/talk-2.png";
import talk3 from "../../../Images/talk-3.png";
import readmorearrow from "../../../Images/readmore-arrow.png";
import ReadMore from "../../CommonUI/ReadMoreBtn/ReadMore";
import "./talkdata.css";

function TalkData() {
    return (
        <>
            <section className="talk-sc">
               <Container>
                    <Row>
                        <Col xl={12}>
                            <div className="section-header">
                                <h2>Market Talks</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>
                            </div>
                        </Col>
                    </Row>
                    <Row className="justify-content-center">
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100" >
                            <div className="talk-data">
                                <img src={talk1}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                </div>
                                {/* <a href="">Know More <span><img src={readmorearrow}></img></span></a> */}
                                <span>    
                                    <ReadMore name="Know" />
                                </span>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk2}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                    <h6>Nifty50 <span className="text-red">-67.95(-2.59%)</span></h6>
                                    <h6>Sensex <span className="text-green">67.95(2.59%)</span></h6>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk3}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk1}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk2}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                    <h6>Nifty50 <span className="text-red">-67.95(-2.59%)</span></h6>
                                    <h6>Sensex <span className="text-green">67.95(2.59%)</span></h6>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk3}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk1}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod  tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk2}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                    <h6>Nifty50 <span className="text-red">-67.95(-2.59%)</span></h6>
                                    <h6>Sensex <span className="text-green">67.95(2.59%)</span></h6>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                        <Col xl={4} lg={4} md={6} sm={6} xs={12} className="width-100">
                            <div className="talk-data">
                                <img src={talk3}></img>
                                <div className="talk-inner">
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna</p>
                                </div>
                                <a href="">Know More <span><img src={readmorearrow}></img></span></a>
                            </div>
                        </Col>
                    </Row>
               </Container>
            </section>
        </>
    )
}

export default TalkData;